// The shapes a photo answer can take, told apart without touching storage: a
// "photo:<key>" reference to an uploaded image, or — on older submissions — the
// image itself inlined as a data URL. Kept apart from photoStorage.js, which
// fetches and uploads, so code that only needs to know whether a photo was
// given (conditions, for one) doesn't pull in the network layer with it.
export const PHOTO_PREFIX = 'photo:';

export const isPhotoRef = (v) => typeof v === 'string' && v.startsWith(PHOTO_PREFIX);
export const isInlinePhoto = (v) => typeof v === 'string' && v.startsWith('data:image/');
export const hasPhotoValue = (v) => isPhotoRef(v) || isInlinePhoto(v);
